import TrashButton from './buttons/TrashButton';
import '../styles/styles.css';
import UpNote from '../assets/icons/up-note.svg';
import DownNote from '../assets/icons/down-note.svg';
import DeleteNote from '../assets/icons/delete-note.svg';

export function NoteActionButton({
    downAction,
    upAction,
    deleteAction,
    cleanAll,
    title,
}: {
    downAction: () => void;
    upAction: () => void;
    deleteAction: () => void;
    cleanAll: () => void;
    title: string;
}) {
    const DownButton = () => {
        return (
            <button className="bottom-action-button" onClick={downAction}>
                <img src={DownNote} style={{ transform: 'scaleY(-1)' }} alt="" />
            </button>
        );
    };
    const UpButton = () => {
        return (
            <button className="bottom-action-button" onClick={upAction}>
                <img src={UpNote} alt="" />
            </button>
        );
    };
    const DeleteButton = () => {
        return (
            <button className="bottom-action-button" onClick={deleteAction}>
                <img src={DeleteNote} alt="" />
            </button>
        );
    };
    return (
        <div className="note-action-buttons">
            <div className="right-section">
                <DownButton />
                <UpButton />
                <DeleteButton />
            </div>
            <div className="left-section">
                <TrashButton cleanAll={cleanAll} />
                {/* <ShareButton title={title} /> */}
            </div>
        </div>
    );
}
